import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './DocumentListHeader.sass'
import Icon from 'components/Icon'
import Tooltip from 'components/Tooltip'
import DocumentsListViewModel from '../DocumentsListViewModel'
import FileButton from 'components/FileButton'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  vm: DocumentsListViewModel
  onQueueFilesUpload: (files: FileList) => void
  showUploadAction: boolean
}

export default observer(function DocumentListHeader({
  vm,
  onQueueFilesUpload,
  showUploadAction,
}: Props) {
  const searchFieldRef = React.useRef<HTMLInputElement>(null)
  const onSearchBarClick = React.useCallback(
    () => searchFieldRef.current && searchFieldRef.current.focus(),
    [],
  )

  const isEmpty = vm.searchText === ''

  return (
    <div className={cx(styles.root)}>
      <div className={styles.searchBar} onClick={onSearchBarClick}>
        <div className={styles.searchIcon}>
          {!isEmpty ? (
            <a
              title="Clear Search"
              className={styles.closeIcon}
              onClick={() => vm.setSearchText('')}
            >
              <Icon name="close" />
            </a>
          ) : (
            <Icon name="search" />
          )}
        </div>
        <input
          ref={searchFieldRef}
          autoComplete="off"
          type="text"
          placeholder="Search Documents"
          className={cx(styles.searchField, !vm.searchText && styles.empty)}
          value={vm.searchText}
          onChange={(e) => vm.setSearchText(e.target.value)}
        />
      </div>
      <div className={styles.filterContainer}>
        {showUploadAction && (
          <Tooltip content="Upload document">
            <div className={styles.icon}>
              <FileButton
                multiple={true}
                onChange={onQueueFilesUpload}
                data-test="upload-document-input-classic"
              >
                <Icon name="add" />
              </FileButton>
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  )
})
